import catFacts from 'cat-facts';

const getCatFact = () => catFacts.random();

export default getCatFact;



// WEBPACK FOOTER //
// src/utils/getCatFact.js